<template>
  <button
    :class="[
      'customize-form-button',
      loading && 'customize-form-button-loading',
      size && `customize-form-button-${size}`
    ]"
    @click="onClick"
  >
    <loading-icon v-if="loading" class="customize-form-button-icon" />
    <slot v-else></slot>
  </button>
</template>

<script>
import loadingIcon from './icon/loading.vue';

export default {
  name: 'CustomizeFormButton',
  components: {
    loadingIcon,
  },
  props: {
    loading: Boolean,
    size: String,
  },

  methods: {
    onClick(e) {
      if (this.loading) return;
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../style/index.scss';

.customize-form-button {
  display: inline-block;
  min-width: 200px;
  padding: 0.7em 2em;
  line-height: 1.5;
  color: var(--customize-form-submit-color);
  font-size: var(--customize-form-submit-font-size);
  font-weight: var(--customize-form-submit-font-weight);
  background: var(--customize-form-submit-bg, var(--customize-form-primary-color));
  border: none;
  border-radius: var(--customize-form-border-radius);
  cursor: pointer;
  transition: opacity $transition-easeinout-001;

  &:hover {
    opacity: 0.85;
  }

  &-icon {
    display: block;
    width: 1.5em;
    height: 1.5em;
    margin: 0 auto;
    animation: $animate-rotate-001;

    ::v-deep {
      path {
        fill: var(--customize-form-submit-color);
      }
    }
  }

  &-loading {
    opacity: 0.8;
    cursor: not-allowed;
  }

  &-small {
    padding: 0.2em 0.5em;
    min-width: 0;
    font-size: 1em;
    font-weight: 400;
  }
}
</style>